module.exports = __webpack_public_path__ + "static/media/Holiday Elf (Series 11).172fbc66.jpg";